import { staticAsset } from './staticAssets.js';
import { getGlossaryTerm as getGlossaryTermStatic, getGlossaryTerms as getGlossaryTermsStatic, groupGlossaryByLetter } from './helpGlossaryTerms.js';
import {
  getInstructionCategories as getInstructionCategoriesStatic,
  getInstructionArticle as getInstructionArticleStatic,
  getInstructionArticles as getInstructionArticlesStatic,
} from './helpInstructionsContent.js';
import {
  getTrainingCategories as getTrainingCategoriesStatic,
  getTrainingArticle as getTrainingArticleStatic,
  getTrainingArticles as getTrainingArticlesStatic,
} from './helpTrainingContent.js';
import {
  HELP_CATEGORIES_I18N,
  HELP_QUESTIONS_I18N,
  HELP_SECTIONS_I18N,
  helpLocaleKey,
} from '../i18n/helpContent.js';
import {
  resolveGlossarySlug,
  resolveHelpCategorySlug,
  resolveHelpQuestionSlug,
  resolveInstructionCategorySlug,
  resolveInstructionArticleSlug,
  resolveTrainingCategorySlug,
} from './helpSlugRedirects.js';
import {
  hasHelpCmsBundle,
  cmsHelpSections,
  cmsFaqCategories,
  cmsFaqQuestions,
  cmsInstructionCategories,
  cmsInstructionArticles,
  cmsInstructionArticle,
  cmsTrainingCategories,
  cmsTrainingArticles,
  cmsTrainingArticle,
  cmsGlossaryTerms,
  cmsGlossaryTerm,
} from './helpCmsRuntime.js';

export { setHelpCmsBundle } from './helpCmsRuntime.js';

export const HELP_BG = staticAsset('/common/website/resources/help/helpBgDark.svg');

import { getHelpCategoryIcon, HELP_CATEGORY_ICONS } from './helpIcons.js';

export const HELP_SECTIONS = HELP_SECTIONS_I18N.tr;

export function readAppLocale() {
  if (typeof window === 'undefined') return 'tr';
  const saved = localStorage.getItem('vb_locale');
  return saved === 'en' ? 'en' : 'tr';
}

export const HELP_CATEGORIES = HELP_CATEGORIES_I18N.en.map((item) => ({
  slug: item.slug,
  title: item.title,
  desc: item.desc,
  icon: getHelpCategoryIcon(item.iconKey),
}));

export const HELP_QUESTIONS = {
  registration: [
    {
      id: 'reg-1',
      slug: 'how-to-register',
      q: 'How do I register?',
      aHtml: '<p>To start placing bets at VurgunBet, you need to register an account and verify your identity.</p><ul><li>Open the <a href="/">registration page</a>.</li><li>Enter your name and phone number.</li><li>Create a unique password.</li><li>Confirm that you are 18 years of age or older and that you agree to the processing of your personal data.</li><li>Wait for an SMS with a confirmation code. Enter this code on the authorization page.</li></ul><p>Your account has been created.</p>',
      views: 42633,
    },
    {
      id: 'reg-2',
      slug: 'how-to-verify',
      q: 'How to complete verification?',
      a: 'Open My Account → Verification and upload photos of your passport. Processing usually takes up to 24 hours on business days.',
      views: 28410,
    },
    {
      id: 'reg-3',
      slug: 'why-verification-required',
      q: 'Why is verification required?',
      a: 'Verification is required by law to confirm your identity and age before you can deposit, withdraw and place bets.',
      views: 19204,
    },
    {
      id: 'reg-4',
      slug: 'register-with-driving-licence',
      q: 'Can I register with a driving licence?',
      a: 'No. Only a valid Turkish ID card or passport can be used for verification.',
      views: 8750,
    },
    {
      id: 'reg-5',
      slug: 'minimum-age',
      q: 'What is the minimum age required to place bets?',
      a: 'You must be at least 18 years old to register and place bets on VurgunBet.',
      views: 15320,
    },
    {
      id: 'reg-6',
      slug: 'how-many-accounts',
      q: 'How many accounts can I have?',
      a: 'Only one account per person is allowed. Duplicate accounts may be blocked and funds withheld.',
      views: 11208,
    },
  ],
  'deposits-withdrawals': [
    {
      id: 'dep-1',
      slug: 'how-to-deposit',
      q: 'How do I deposit?',
      a: 'Log in, open the cashier, choose a payment method, enter the amount and confirm. Funds are credited instantly for most methods.',
      views: 35600,
    },
    {
      id: 'dep-2',
      slug: 'how-to-withdraw',
      q: 'How do I withdraw winnings?',
      a: 'Go to Cashier → Withdraw, select the same method used for deposit where possible, enter amount and confirm. First withdrawal requires completed verification.',
      views: 29840,
    },
    {
      id: 'dep-3',
      slug: 'deposit-withdrawal-limits',
      q: 'What are the limits?',
      a: 'Minimum deposit is 2 TL. Minimum withdrawal is 10 TL. Maximum limits depend on your verification level and payment method.',
      views: 16420,
    },
  ],
  'personal-data': [
    {
      id: 'pd-1',
      slug: 'recover-password',
      q: 'How do I recover my password?',
      a: 'On the login screen click Forgot password, enter your phone number and follow the SMS instructions to set a new password.',
      views: 22100,
    },
    {
      id: 'pd-2',
      slug: 'change-email',
      q: 'How do I change my email?',
      a: 'Open My Account → Personal data, enter a new email and confirm it via the link sent to your inbox.',
      views: 9800,
    },
    {
      id: 'pd-3',
      slug: 'update-id-documents',
      q: 'How do I update passport details?',
      a: 'Contact support with scanned documents if your passport was reissued. Self-service editing is not available after verification.',
      views: 7200,
    },
  ],
  bets: [
    {
      id: 'bet-1',
      slug: 'minimum-bet',
      q: 'What is the minimum bet?',
      a: 'The minimum single bet is 0.20 TL. Express and system bets have the same minimum per selection.',
      views: 18900,
    },
    {
      id: 'bet-2',
      slug: 'live-vs-prematch',
      q: 'What is the difference between Live and Pre-match?',
      a: 'Pre-match bets are placed before the event starts. Live bets are accepted during the event with odds updated in real time.',
      views: 14300,
    },
    {
      id: 'bet-3',
      slug: 'cancelled-event',
      q: 'What happens if an event is cancelled?',
      a: 'If an event is cancelled or postponed beyond 48 hours, single bets on that event are void and stakes refunded at odds of 1.00.',
      views: 11500,
    },
  ],
  'promotions-bonuses': [
    {
      id: 'bon-1',
      slug: 'promo-code',
      q: 'How do I use a promo code?',
      a: 'Enter the code in My Account → Bonuses or in the deposit screen before confirming payment. Each code can be used once unless stated otherwise.',
      views: 25400,
    },
    {
      id: 'bon-2',
      slug: 'free-bet',
      q: 'How are free bets calculated?',
      a: 'Free bet stake is not returned with winnings. If a free bet wins, you receive net profit only (payout minus free bet amount).',
      views: 19800,
    },
  ],
  'technical-support': [
    {
      id: 'tech-1',
      slug: 'contact-support',
      q: 'How do I contact support?',
      a: 'Use live chat on the site, Telegram, or write to destek@vurgunbet.com. Support is available 24/7.',
      views: 31200,
    },
    {
      id: 'tech-2',
      slug: 'submit-support-request',
      q: 'How do I submit a request through My Account?',
      a: 'Open My Account → Support → New request, describe the issue and attach screenshots if needed. You will receive a reply by email.',
      views: 12600,
    },
    {
      id: 'tech-3',
      slug: 'marketing-emails',
      q: 'How do I subscribe to promotional emails?',
      a: 'In My Account → Notifications enable marketing emails. You can unsubscribe at any time via the link in any email.',
      views: 8400,
    },
  ],
};

function localizedCategories(locale) {
  if (hasHelpCmsBundle()) return cmsFaqCategories();
  const key = helpLocaleKey(locale);
  return HELP_CATEGORIES_I18N[key].map((item) => ({
    slug: item.slug,
    title: item.title,
    desc: item.desc,
    icon: getHelpCategoryIcon(item.iconKey),
  }));
}

function localizedQuestions(locale) {
  if (hasHelpCmsBundle()) return cmsFaqQuestions();
  const key = helpLocaleKey(locale);
  if (key === 'tr') return HELP_QUESTIONS_I18N.tr;
  return HELP_QUESTIONS;
}

export function getHelpCategories(locale = 'tr') {
  return localizedCategories(locale);
}

export function getHelpSections(locale = 'tr') {
  if (hasHelpCmsBundle()) {
    const sections = cmsHelpSections();
    if (sections?.length) return sections;
  }
  return HELP_SECTIONS_I18N[helpLocaleKey(locale)];
}

export function getHelpCategory(slug, locale = 'tr') {
  const resolved = resolveHelpCategorySlug(slug);
  return localizedCategories(locale).find((c) => c.slug === resolved) || null;
}

export function getHelpQuestions(slug, locale = 'tr') {
  return localizedQuestions(locale)[resolveHelpCategorySlug(slug)] || [];
}

export function getHelpQuestion(categorySlug, questionSlug, locale = 'tr') {
  const category = resolveHelpCategorySlug(categorySlug);
  const question = resolveHelpQuestionSlug(questionSlug);
  return (localizedQuestions(locale)[category] || []).find(
    (item) => item.slug === question || item.id === questionSlug,
  ) || null;
}

export function searchHelpQuestions(query, locale = 'tr') {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const results = [];
  localizedCategories(locale).forEach((cat) => {
    (localizedQuestions(locale)[cat.slug] || []).forEach((item) => {
      if (item.q.toLowerCase().includes(q) || (item.a && item.a.toLowerCase().includes(q)) || (item.aHtml && item.aHtml.toLowerCase().includes(q))) {
        results.push({ ...item, category: cat });
      }
    });
  });
  return results;
}

export function getPopularHelpSearches(locale = 'tr') {
  return [
    {
      categorySlug: 'registration',
      questionSlug: 'how-to-verify',
      labelKey: 'help.popular.identification',
    },
    {
      categorySlug: 'deposits-withdrawals',
      questionSlug: 'how-to-deposit',
      labelKey: 'help.popular.deposit',
    },
    {
      categorySlug: 'deposits-withdrawals',
      questionSlug: 'how-to-withdraw',
      labelKey: 'help.popular.win',
    },
  ];
}

export function helpPath(sectionId, categorySlug, questionSlug, locale = 'tr') {
  const section = getHelpSections(locale).find((s) => s.id === sectionId) || getHelpSections(locale)[0];
  if (sectionId === 'faq') {
    const category = categorySlug ? resolveHelpCategorySlug(categorySlug) : null;
    const question = questionSlug ? resolveHelpQuestionSlug(questionSlug) : null;
    if (category && question) {
      return `/help-center/${section.path}/${category}/${question}`;
    }
    if (category) {
      return `/help-center/${section.path}/${category}`;
    }
    return `/help-center/${section.path}`;
  }
  if (sectionId === 'glossary') {
    const term = questionSlug ? resolveGlossarySlug(questionSlug) : null;
    if (term) return `/help-center/${section.path}/${term}`;
    return `/help-center/${section.path}`;
  }
  if (sectionId === 'instructions') {
    const category = categorySlug ? resolveInstructionCategorySlug(categorySlug) : null;
    const article = questionSlug ? resolveInstructionArticleSlug(questionSlug) : null;
    if (category && article) {
      return `/help-center/${section.path}/${category}/${article}`;
    }
    if (category) {
      return `/help-center/${section.path}/${category}`;
    }
    return `/help-center/${section.path}`;
  }
  if (sectionId === 'training') {
    const category = categorySlug ? resolveTrainingCategorySlug(categorySlug) : null;
    const article = questionSlug || null;
    if (category && article) {
      return `/help-center/${section.path}/${category}/${article}`;
    }
    if (category) {
      return `/help-center/${section.path}/${category}`;
    }
    return `/help-center/${section.path}`;
  }
  return `/help-center/${section.path}`;
}

export function parseHelpRoute(pathname, locale = 'tr') {
  const parts = pathname.replace(/^\/help-center\/?/, '').split('/').filter(Boolean);
  const sections = getHelpSections(locale);
  const section = sectionFromPathPart(parts[0], locale) || sections[0];
  let categorySlug = null;
  let questionSlug = null;

  if (section.id === 'faq') {
    categorySlug = parts[1] ? resolveHelpCategorySlug(parts[1]) : null;
    questionSlug = parts[2] ? resolveHelpQuestionSlug(parts[2]) : null;
  } else if (section.id === 'glossary') {
    questionSlug = parts[1] ? resolveGlossarySlug(parts[1]) : null;
  } else if (section.id === 'instructions') {
    categorySlug = parts[1] ? resolveInstructionCategorySlug(parts[1]) : null;
    questionSlug = parts[2] ? resolveInstructionArticleSlug(parts[2]) : null;
  } else if (section.id === 'training') {
    categorySlug = parts[1] ? resolveTrainingCategorySlug(parts[1]) : null;
    questionSlug = parts[2] || null;
  } else {
    categorySlug = parts[1] || null;
    questionSlug = parts[2] || null;
  }

  return { sectionId: section.id, categorySlug, questionSlug };
}

export function sectionFromPathPart(part, locale = 'tr') {
  const sections = getHelpSections(locale);
  if (!part) return sections[0];

  const aliases = {
    faq: ['faq', 'sss', 'vopros-otvet'],
    instructions: ['instructions', 'talimatlar', 'instrukcii'],
    training: ['training', 'egitim', 'obuchenie'],
    glossary: ['glossary', 'sozluk', 'glossariy', 'slovar-terminov'],
  };

  for (const section of sections) {
    const paths = aliases[section.id] || [section.path];
    if (paths.includes(part)) return section;
  }

  return sections.find((s) => s.path === part);
}

export function isHelpRouteNotFound(pathname, locale = 'tr') {
  const parts = pathname.replace(/^\/help-center\/?/, '').split('/').filter(Boolean);
  if (!parts.length) return false;

  const section = sectionFromPathPart(parts[0], locale);
  if (!section) return true;

  if (section.id === 'faq') {
    if (!parts[1]) return false;
    if (!getHelpCategory(parts[1], locale)) return true;
    if (parts[2] && !getHelpQuestion(parts[1], parts[2], locale)) return true;
    return parts.length > 3;
  }

  if (section.id === 'glossary') {
    if (!parts[1]) return false;
    if (!getGlossaryTerm(parts[1], locale)) return true;
    return parts.length > 2;
  }

  if (section.id === 'instructions') {
    if (!parts[1]) return false;
    const categories = getInstructionCategories(locale);
    if (!categories.find((item) => item.slug === resolveInstructionCategorySlug(parts[1]))) return true;
    if (parts[2] && !getInstructionArticle(parts[1], parts[2], locale)) return true;
    return parts.length > 3;
  }

  if (section.id === 'training') {
    if (!parts[1]) return false;
    const categories = getTrainingCategories(locale);
    if (!categories.find((item) => item.slug === resolveTrainingCategorySlug(parts[1]))) return true;
    if (parts[2] && !getTrainingArticle(parts[1], parts[2], locale)) return true;
    return parts.length > 3;
  }

  return false;
}

export function getGlossaryTerms(locale = 'tr') {
  if (hasHelpCmsBundle()) return cmsGlossaryTerms();
  return getGlossaryTermsStatic(locale);
}

export function getGlossaryTerm(slug, locale = 'tr') {
  const resolved = resolveGlossarySlug(slug);
  if (hasHelpCmsBundle()) return cmsGlossaryTerm(resolved);
  return getGlossaryTermStatic(resolved, locale);
}

export function getInstructionCategories(locale = 'tr') {
  if (hasHelpCmsBundle()) return cmsInstructionCategories();
  return getInstructionCategoriesStatic(locale);
}

export function getInstructionArticles(catSlug, locale = 'tr') {
  const resolved = resolveInstructionCategorySlug(catSlug);
  if (hasHelpCmsBundle()) return cmsInstructionArticles(resolved);
  return getInstructionArticlesStatic(resolved, locale);
}

export function getInstructionArticle(catSlug, articleSlug, locale = 'tr') {
  const category = resolveInstructionCategorySlug(catSlug);
  const article = resolveInstructionArticleSlug(articleSlug);
  if (hasHelpCmsBundle()) return cmsInstructionArticle(category, article);
  return getInstructionArticleStatic(category, article, locale);
}

export function getTrainingCategories(locale = 'tr') {
  if (hasHelpCmsBundle()) return cmsTrainingCategories();
  return getTrainingCategoriesStatic(locale);
}

export function getTrainingArticles(catSlug, locale = 'tr') {
  const resolved = resolveTrainingCategorySlug(catSlug);
  if (hasHelpCmsBundle()) return cmsTrainingArticles(resolved);
  return getTrainingArticlesStatic(resolved, locale);
}

export function getTrainingArticle(catSlug, articleSlug, locale = 'tr') {
  const category = resolveTrainingCategorySlug(catSlug);
  if (hasHelpCmsBundle()) return cmsTrainingArticle(category, articleSlug);
  return getTrainingArticleStatic(category, articleSlug, locale);
}

export { groupGlossaryByLetter };